import _ from 'lodash';
import { Component, Input, Output, EventEmitter} from '@angular/core';
import { PagerService, PortNmMapModel, AlertService, PortService, Port, VesselService, Oper, SaveLocationModel} from 'app/services/index'
declare var $:any;

@Component({
  selector: 'port-map-update-list',
  templateUrl: 'port-map-update-list.html'
})
export class PortMapUpdateListComponent {

    _isOpen = false;
    _portMapList:Array<PortNmMapModel> = new Array<PortNmMapModel>();
    operTypeList:Array<any> = new Array<any>();
    stusList:Array<any> = new Array<any>();
    scraperTypeList:Array<any> = new Array<any>();
    
    @Output() onRefresh: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();

    pager: any = {};
    pagedItems: any[];

    allStatus:any = null;

    @Input() operList:Array<Oper> = new Array();
    @Input() portList:Array<Port> = new Array();
    
    constructor(   
        private pagerService: PagerService,
        private alertService:AlertService,
        private portService:PortService,
        private vesselService:VesselService
    ) {

    }

    @Input() 
    set portMapList(portMapList){
        if(!portMapList) return ;
        this._portMapList = portMapList;
        this.setPage(1);
    }

    get portMapList(){
        return this._portMapList;
    }


    @Input() set openFlag(flag){
        this._isOpen = true;
    }

    ngOnDestroy(){
        
    }

    ngOnInit() {
        this._isOpen = false;
        this.initMake();

        this.portService.portListEe.subscribe(
            data => {
                this.portList = data;
            }
        );
        if(!this.portService.ingFlag){
            this.portService.getPortList();
        }


    }

    initMake(){
        this.operTypeList.push({text:'SHIP_OPERATOR', id:'0'});
        this.operTypeList.push({text:'TERMINAL', id:'1'});
        this.operTypeList.push({text:'FORWARDER', id:'2'});

        this.stusList.push({text:'REQUEST', id:'0'});
        this.stusList.push({text:'MAPPED', id:'1'});
        this.stusList.push({text:'SKIP', id:'2'});
        this.stusList.push({text:'TEMPMAPPED', id:'3'});
        this.stusList.push({text:'CHECK', id:'4'});
        this.stusList.push({text:'NONE', id:'5'});

        this.scraperTypeList.push({text:'P2P_SCHEDULE', id:'0'});
        this.scraperTypeList.push({text:'BERTH_PLAN', id:'1'});
        this.scraperTypeList.push({text:'LCL_SCHEDULE', id:'2'});
        this.scraperTypeList.push({text:'VESSEL_SCHEDULE', id:'3'});
        this.scraperTypeList.push({text:'AIR_SCHEDULE', id:'4'});
        this.scraperTypeList.push({text:'TRACKING', id:'5'});
    }

    setPage(page: number) {
        this.pager = this.pagerService.getPager(this.portMapList.length, page, 5);

        // if (page < 1) {
        //     return;
        // } 

        this.pagedItems = this.portMapList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

    selecedOper(event:any) {
        let oper:Oper = event.data;
        let index:number = event.index;
        if(oper) {
            this.portMapList[index].operCd = oper.operCd;
            this.portMapList[index].operTpCd = oper.operTpCd;
            this.portMapList[index].operTpNm = oper.operTpNm;
        } else {
            this.portMapList[index].operCd = null;
            this.portMapList[index].operTpCd = null;
            this.portMapList[index].operTpNm = null;
        }
    }

    selecedMapping(event:any){
        let location:SaveLocationModel = event.data;
        let index:number = event.index;
        if(location) {
            this.portMapList[index].location = location;
        } else {
            this.portMapList[index].location = null;
        }
    }

    selected(values:any, type:string, index:number){
        if(type.indexOf('STATUS') > -1){
            this.portMapList[index].stusCd = Number(values.id);
            this.portMapList[index].stusNm = values.text;
        }
        // else{
        //     this.vesselMapList[index].reqSystemCd = Number(values.id);
        //     this.vesselMapList[index].reqSystemNm = values.text;
        // }
    }

    save(){
        let that = this;
        $.sweetModal.confirm('저장하시겠습니까?', function() {
            that.portMapList = _.map(that.portMapList, (portMap:PortNmMapModel) =>{
                if(portMap.stusCd == 1 && portMap.location == null) portMap.stusCd = 0;
                return portMap;
            });
            that.portService.patchPortMap(that.portMapList).subscribe(
                res =>{
                    if(res.result){
                        that.alertService.success("저장 되었습니다.");
                        that.onRefresh.emit(1);
                    }
                }
            );   

        }, function() {
        });
    }

    close(){
        this.onClose.emit();
        this.portMapList = null;
        this.allStatus = null;
    }

    selectStatus(values){
        this.portMapList = _.map(this.portMapList, (portMap:PortNmMapModel) => {
            portMap.stusNm = values.text;
            portMap.stusCd = Number(values.id);
            return portMap;
        });
    }
}





// WEBPACK FOOTER //
// ./src/app/containers/port-map/port-map-update-list.ts